import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import dracula from 'react-syntax-highlighter/dist/esm/prism'
import CopyButton from '../copyButton'
import './index.scss'
import './prism-dracula.css'

const CustomCodeViewer = ({language, code, wrapLongLines = false}) => {
    return (
        <div className="code-viewer">
            <CopyButton text={code}/>
            <SyntaxHighlighter
                language={language}
                style={dracula}
                wrapLongLines={wrapLongLines}
            >
                {code}
            </SyntaxHighlighter>
        </div>
    )
}

export default CustomCodeViewer
